import moment from 'moment'
import Vue from 'vue'

Vue.filter('trackset', function(value: string) {
  switch(value){
    case "GGL": return "Adwords"
  }
  return value;
})